const isDevelopment = process.env.NODE_ENV === "development";

// Google always-pass test key for local/dev (domains/localhost safe).
// https://developers.google.com/recaptcha/docs/faq#id-like-to-run-automated-tests-with-recaptcha.-what-should-i-do
const RECAPTCHA_DEV_SITE_KEY = "6LcfcfoSAAAAAKJdKnmZknTSQOmMTFdlmEjWUjdT";
const RECAPTCHA_PROD_SITE_KEY = "6Ld9JMsqAAAAAOJEgRP593zS78oGiEmMVIAaTkn6";

const config = {
  RECAPTCHA_SITE_KEY:
    process.env.REACT_APP_RECAPTCHA_SITE_KEY ||
    (isDevelopment ? RECAPTCHA_DEV_SITE_KEY : RECAPTCHA_PROD_SITE_KEY),
  YOUTUBE_API_KEY: "AIzaSyCY22s-XrlAgUG6a6wnKoJ3eWCqsJYX0tU",
  API_LOGIN_USER_URL:
    "https://apis.sihs.org.pk/api/PatientPortal/Login?DeviceID={DeviceID}&PhoneNo={PhoneNo}&OTP={OTP}&PushToken={PushToken}",
  API_SEND_OTP_URL:
    "https://apis.sihs.org.pk/api/PatientPortal/Gen_OTP?DeviceID={DeviceID}&PhoneNo={PhoneNo}&operatorCode={operatorCode}&PushToken={PushToken}",
  API_REMOVE_PATIENT_URL:
    "https://apis.sihs.org.pk/api/PatientPortal/RemovePatient?PhoneNo={PhoneNo}&Mrno={Mrno}",
  API_APPOINT_LIST_URL:
    "https://apis.sihs.org.pk/api/Appointment/GetAppointmentList?PhoneNo={PhoneNo}",
  API_CANCEL_APPOINTMENT_URL:
    "https://apis.sihs.org.pk/api/Appointment/CancelAppointment?PhoneNo={PhoneNo}&AppointmentID={AppointmentID}&Reason={Reason}",
  API_GET_DEPARTMENTS_URL:
    "https://apis.sihs.org.pk/api/Appointment/GetDepartments",
  API_GET_DOCTORS_URL:
    "https://apis.sihs.org.pk/api/Appointment/GetDepartmentsDoctors?DeptID={DeptID}",
  API_FETCH_DATES_URL:
    "https://apis.sihs.org.pk/api/Appointment/GetAppointmentDatesByDoctors?DoctorID={DoctorID}",
  API_FETCH_TIME_SLOTS_URL:
    "https://apis.sihs.org.pk/api/Appointment/GetAppointmentSlotsByDoctors?DoctorID={DoctorID}&theDate={theDate}",
  API_BOOK_APPOINTMENT_URL:
    "https://apis.sihs.org.pk/api/Appointment/AddAppointmentupdated" +
    "?PhoneNo={PhoneNo}" +
    "&MRNO={MRNO}" +
    "&PatientName={PatientName}" +
    "&Father={Father}" +
    "&AgeInNumbers={AgeInNumbers}" +
    "&AgeCaption={AgeCaption}" +
    "&Gender={Gender}" +
    "&Remarks={Remarks}" +
    "&Address={Address}" +
    "&StartDateTime={StartDateTime}" +
    "&DrID={DrID}" +
    "&AptType={AptType}",
  API_CONTACT_US_URL:
    "https://apis.sihs.org.pk/api/PatientPortal/ContactUs?Name={Name}&Email={Email}&Message={Message}",
  API_ADD_PATIENT_URL:
    "https://apis.sihs.org.pk/api/PatientPortal/AddPatient?PhoneNo={PhoneNo}&PatientName={PatientName}&Father={Father}&AgeInNumbers={AgeInNumbers}&AgeCaption={AgeCaption}&Gender={Gender}&Relation={Relation}&Address={Address}&CNIC={CNIC}&GCNIC={GCNIC}",
  API_SEARCH_DOCTOR_URL:
    "https://apis.sihs.org.pk/api/Appointment/SearchDoctor",
  API_GET_APPOINT_DATES_URL:
    "https://apis.sihs.org.pk/api/Appointment/GetAppointmentDatesByDoctors?DoctorID={DoctorID}",
  API_ADD_PATIENT_VITALS:
    "https://apis.sihs.org.pk/api/PatientPortal/AddPatientVitalLabData?PhoneNo={PhoneNo}&MRNO={MRNO}&DashboardItemId={DashboardItemId}&theDate={theDate}&Val1={Val1}&Val2={Val2}",
  API_GET_DASHBOARD_GRAPH:
    "https://apis.sihs.org.pk/api/Appointment/GetDashboardItemGraph?PhoneNo={PhoneNo}&MRNO={MRNO}&DashboardItemID={DashboardItemID}",
  API_GET_DASHBOARD_ITEM_GRAPH_URL:
    "https://apis.sihs.org.pk/api/Appointment/GetDashboardItemGraph?PhoneNo={PhoneNo}&MRNO={MRNO}&DashboardItemID={DashboardItemID}",
  API_GET_PATIENT_UNSEENREPORT_URL:
    "https://apis.sihs.org.pk/api/PatientPortal/GetPatientUnSeenReportGroupByTAB?PhoneNo={PhoneNo}&MRNO={MRNO}",
  API_GET_PATIENT_REPORT:
    "https://apis.sihs.org.pk/api/PatientPortal/GetPatientReport?PhoneNo={PhoneNo}&MRNO={MRNO}&TabID={TabID}&ReportType={ReportType}&TestID={TestID}&InvoiceNo={InvoiceNo}&ServiceID={ServiceID}",
  API_GET_PATIENT_REPORT_LIST_BY_TYPE_URL:
    "https://apis.sihs.org.pk/api/PatientPortal/GetPatientReportListByType?PhoneNo={PhoneNo}&MRNO={MRNO}&TabID={TabID}",
  API_GOOGLE_API_YOUTUBE_URL:
    "https://www.googleapis.com/youtube/v3/search?key={apiKey}&channelId={channelId}&part=snippet,id&order=date&maxResults=1",
  API_INITIATE_PAYMENT_URL:
    "https://paymentgateway-d83a.onrender.com/api/initiatePaymentAppointment",
  API_FINALIZE_PAYMENT_URL:
    "https://paymentgateway-d83a.onrender.com/api/finalizePaymentAppointment",
  API_VIEW_FILE_URL:
    "https://apis.sihs.org.pk/api/EmployeePortal/AppointmentFileView?DeviceID={DeviceID}&UserID={UserID}",
  API_DELETE_FILE_URL:
    "https://apis.sihs.org.pk/api/EmployeePortal/AppointmentFileDelete?DeviceID={DeviceID}&UserID={UserID}",
  API_ADD_FILE_URL:
    "https://apis.sihs.org.pk/api/PatientPortal/AppointmentFileAdd?DeviceID={DeviceID}&UserID={UserID}",
  API_MEETING_LINK_URL:
    "https://apis.sihs.org.pk/api/Appointment/JoinMeeting?UserID={UserID}&appointmentID={appointmentID}",
  API_RESCHEDULE_APPOINTMENT_URL:
    "https://apis.sihs.org.pk/api/Appointment/ReScheduleAppointment?PhoneNo={PhoneNo}&AptID={AptID}&StartDateTime={StartDateTime}&DrID={DrID}",
  API_REFUND_APPOINTMENT_URL:
    "https://apis.sihs.org.pk/api/Appointment/ReFundAppointment?PhoneNo={PhoneNo}&AptID={AptID}&StartDateTime={StartDateTime}&DrID={DrID}",
  API_DIALYSIS_SESSIONS_URL:
    "https://apis.sihs.org.pk/api/DialPt_Sessions?UserID={UserID}&DeviceID={DeviceID}&MRNo={MRNo}",
  API_GET_SERVICE_INVOICE_URL:
    "https://apis.sihs.org.pk/api/PatientPortal/GetSrvInvoice?DeviceID={DeviceID}&PhoneNo={PhoneNo}&MRNo={MRNo}&InvoiceID={InvoiceID}&TabID={TabID}",
};

export default config;
